import { DataSource, Layout, Table, } from "@mcleod/components";

export abstract class AutogenLayoutCommentTypeLookup extends Layout {
    sourceCommentType: DataSource;
    tableCommentType: Table;
}
